import React, { useCallback, useEffect, useState } from "react";
import "./side-menu.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faHome,
  faBookOpen,
  faCog,
  faUsers,
  faEdit
} from "@fortawesome/free-solid-svg-icons";
import { faCheckCircle } 
from "@fortawesome/free-regular-svg-icons"
import { Link, useHistory, useLocation } from 'react-router-dom';
import { storage } from "../../firebase/index";



export default function SideMenu() {
  const history = useHistory();
  const location = useLocation();
  const [hovered, setHovered] = useState('');
  const toggleHover = (hoovered: string) => setHovered(hoovered);



  const menuItemHome = (
    <FontAwesomeIcon className="menu-icon"
      icon={faHome}
    />
  );
  const menuItemCheckList = (
    <FontAwesomeIcon className="menu-icon"
      icon={faCheckCircle}
    />
  );

  const menuBookOpen = (
    <FontAwesomeIcon className="menu-icon"
      icon={faBookOpen}
    />
  );

  const menuItemAbout = (
    <FontAwesomeIcon className="menu-icon"
      icon={faUsers}
    />
  );

  const menuItemInstructions = (
    <FontAwesomeIcon className="menu-icon"
      icon={faCog}
    />
  );

  const menuItemDownload = (
    <FontAwesomeIcon className="menu-icon"
      icon={faEdit}
    />
  );

  const download = async () => {
    const pdfUrl = await storage.ref('Ivris Checklista Anteckningar.pdf').getDownloadURL();
    window.open(pdfUrl, "_blank")
  }
  const handleOnClick = useCallback((path) => { history.push(path); }, [history]);
  //probabil se putea cumva fara translate
  const nameWidth = (path?: string): any => {
    if ('/' === path) return { width: '160px', transform: 'translateX(50px)' }
    if ('/introduktion' === path) return { width: '240px', transform: 'translateX(80px)' }
    if ('/hurfunkardet' === path) return { width: '270px', transform: 'translateX(100px)' }
    if ('/checklista' === path) return { width: '230px', transform: 'translateX(80px)' }
    if ('/omoss' === path) return { width: '170px', transform: 'translateX(50px)' }
    if ('pdf' === path) return { width: '180px', transform: 'translateX(50px)' }




  }
  const menuItem = (icon: any, name: string, handleOnClick: (path?: string) => any, route: string) => {
    return (
      <div
        style={hovered === route ? nameWidth(route) : {}}
        className={`menu-item-wrapper ${hovered === route ? 'menu-item-wrapper-hoov' : ''} ${location.pathname === route ? 'is-active' : ''}`}>
        <div className={'menu-item'}
          style={{ transform: location.pathname === route ? "translateX(-10px)" : "translateX(0)" }}
          onClick={() => route === 'pdf' ? null : handleOnClick(route)}
          onMouseEnter={() => toggleHover(route)}
          onMouseLeave={() => toggleHover('')}
        >
          {route === 'pdf' ? <Link to="Ivris.pdf" style={{ textDecoration: 'none' }}
              target="_blank" download>
                <div style={{display: 'flex'}}>
                <span style={{ marginTop: '13px', color: location.pathname === route || hovered === route ? "#F2d58F" : "white" }}>
                    {icon}
                </span>
                <span style={{ display: hovered === route ? 'inline' : 'none', paddingLeft: "10px" }} className='menu-item-text'> 
                  {name}
                </span>
                </div>
                
                </Link>
                :
                <div style={{display: 'flex'}}>
                <span style={{ marginTop: '13px', color: location.pathname === route || hovered === route ? "#F2d58F" : "white" }}>
                    {icon}
                </span>
                <span style={{ display: hovered === route ? 'inline' : 'none', paddingLeft: "10px" }} className='menu-item-text'> 
                  {name}
                </span>
                </div>
            }

                

          

        </div>
      </div>
    );
  };


  // history.listen((location, action) => {
  //     setRoute(location.pathname);
  // });


  return (
    <div id="menu-placeholder">
      <div className="menu-container">
        <div className="btns-container" >
          {menuItem(menuItemHome, "HEM", handleOnClick, '/')}
          {menuItem(menuBookOpen, "INTRODUKTION", handleOnClick, '/introduktion')}
          {menuItem(menuItemInstructions, "HUR FUNKAR DET?", handleOnClick, '/hurfunkardet')}
          {menuItem(menuItemCheckList, "STARTA CHECKLISTAN", handleOnClick, '/checklista')}
          {menuItem(menuItemAbout, "OM OSS", handleOnClick, '/omoss')}
          {menuItem(menuItemDownload, "HÄMTA PDF", handleOnClick, 'pdf')}

        </div>
      </div>
    </div>
  );
}




